export const INVOICING_CONFIG_FOR_PAYER = "INVOICING_CONFIG_FOR_PAYER";
export const INVOICING_CONFIG_FOR_PAYEE = "INVOICING_CONFIG_FOR_PAYEE";
